import "../css/ActionCard.css";

export default function ActionCard({ onClick, onContextMenu, icon, title }) {
  return (
    <button
      className="action-card"
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      <span className="info-card">
        {icon}
        <span className="action-text">
          <span className="h4-p2">{title}</span>
        </span>
      </span>
    </button>
  );
}
